module.exports = __webpack_public_path__ + "static/img/push-notific.9e69bd80.svg";